import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";

import userService from "@/services/user";
import apiConfig from "@/config/api";

const logout = () => {
  const storedAuth = localStorage.getItem("auth");

  if (storedAuth) {
    const auth = JSON.parse(storedAuth);

    userService.setLoginHistory(auth.uid);
    localStorage.removeItem("user");
    localStorage.removeItem("auth");
    setTimeout(() => {
      window.location.href = "/home";
    }, 0);
  }
};

export const customBaseQuery: BaseQueryFn<string | FetchArgs, any, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const storedAuth = localStorage.getItem("auth");

  const baseQuery = fetchBaseQuery({
    baseUrl: apiConfig.apiBaseURL,
    prepareHeaders: (headers) => {
      if (storedAuth) {
        const auth = JSON.parse(storedAuth);

        headers.set("uid", auth.uid);
        headers.set("client", auth.client);
        headers.set("access-token", auth["access-token"]);

        return headers;
      }
    },
  });

  const result = await baseQuery(args, api, extraOptions);

  const status = result.error?.status;

  if (status === 401) {
    logout();
  }

  const auth = storedAuth ? JSON.parse(storedAuth) : undefined;
  const headers = result?.meta?.response?.headers;

  // Compare current auth with response headers
  const authKeys = ["client", "uid", "expiry", "access-token"];
  const isSame = auth && headers && authKeys.every((key) => auth[key] === headers.get(key));

  if (!isSame && headers?.get("access-token") && status === 200) {
    // Update token locally
    localStorage.setItem(
      "auth",
      JSON.stringify({
        client: headers?.get("client"),
        uid: headers?.get("uid"),
        expiry: headers?.get("expiry"),
        "access-token": headers?.get("access-token"),
      }),
    );
  }

  return result;
};
